// // import React from "react";
// // import { HomeContent } from "../Components/HomeContent";

// // const Home = () => {
// //   return <HomeContent />;
// // };

// // export default Home;
// // src/modules/Home/Page/Home.jsx
// import React from "react";
// import { getSEOData } from "../../../global/utils/constants/seoConfig";
// // Import your existing Home components here
// // import Banner from "../Components/Banner";
// // import Features from "../Components/Features";
// // etc...
// import { HomeContent } from "../Components/HomeContent";
// import SEO from "../../../global/components/SEO/SEO";
// const Home = () => {
//   const seoData = getSEOData("/");

//   return (
//     <>
//       <SEO
//         title={seoData.title}
//         description={seoData.description}
//         keywords={seoData.keywords}
//         type="website"
//       />
//       <HomeContent />
//     </>
//   );
// };

// export default Home;
import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import { HomeContent } from "../Components/HomeContent";
import SEO from "../../../global/components/SEO/SEO";

const Home = () => {
  const seoData = getSEOData("/");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <HomeContent />
    </>
  );
};

export default Home;
